import registry from './policies.json';
import { getActivePolicySet } from './policyRules';
export { getActivePolicySet, getPublishedPolicySet, isPolicyAcceptanceValid } from './policyRules';

export const POLICY_IDS = ['terms', 'privacy', 'refunds'];
export const POLICY_DESCRIPTIONS = {
  terms: 'Your gallery, your content and what to expect from Wedlinx.',
  privacy: 'What we collect, why we need it and the choices you have.',
  refunds: 'When you can request a refund and what happens next.',
};

export function policyPath(policy, version) {
  return `/legal/${encodeURIComponent(policy)}${version ? `/${encodeURIComponent(version)}` : ''}`;
}

export function getPolicy(policy, requestedVersion, source = registry, now = Date.now()) {
  if (!POLICY_IDS.includes(policy)) return null;
  const active = getActivePolicySet(now, source);
  const version = requestedVersion ?? active?.version ?? source.currentVersion ?? source.previewVersion;
  if (!Object.prototype.hasOwnProperty.call(source.versions, version)) return null;
  const release = source.versions[version];
  const isScheduled = release.status === 'published'
    && Date.parse(`${release.effectiveDate}T00:00:00+08:00`) > now;
  const document = release.policies[policy];
  if (!document) return null;
  return {
    ...document,
    version,
    status: release.status,
    effectiveDate: release.effectiveDate,
    isCurrent: version === active?.version,
    isArchived: release.status === 'published' && !isScheduled && version !== active?.version,
    isScheduled,
  };
}

export function policyVersions(policy, source = registry) {
  return Object.keys(source.versions).filter((version) => getPolicy(policy, version, source));
}

export function formatPolicyDate(value) {
  return new Intl.DateTimeFormat('en-SG', {
    day: 'numeric', month: 'long', year: 'numeric', timeZone: 'Asia/Singapore',
  }).format(new Date(`${value}T00:00:00+08:00`));
}

export default registry;
